<template>
    <div id="duixiang">
        <h5>{{ group_name }}</h5>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="1" />
            </el-aside>
            <el-main>
                <DuixiangTable :group_id="group_id" />
            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import { Tag } from 'iview';
import SubMenu from './SubMenu.vue'
import DuixiangTable from './cell/DuixiangTable.vue'
export default {
    components: {
        Tag,
        SubMenu,
        DuixiangTable
    },
    data() {
        return {
            group_id: '',
            group_name: ''

        }

    },
    created() {
        this.group_id = this.$route.params.group_id
        this.getGroup()

    },
    methods: {
        getGroup() {
            let url = config.base_url + '/yun_table/yun_duixiang_groups/' + this.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data
                this.group_id = res.group_id
                this.group_name = res.group_name
            })
        },
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>